var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('br'),_c('br'),_c('div',{staticClass:"row justify-content-center"},[_c('div',{staticClass:"col-auto"},[_c('button',{staticClass:"btn btn-primary p-3 d-flex align-items-center",on:{"click":_vm.printReceipt}},[_c('i',{staticClass:"bi bi-printer fs-1 px-2"}),_vm._v(" Print Receipt ")])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }